export default __webpack_public_path__ + "static/media/espol_doc_logo_der.fafcfca9.png";